import { NavLink as RouterNavLink } from 'react-router-dom';
import { ReactNode } from 'react';
import { Logo } from './ui/logo';
import {
  LayoutDashboard, Users, FileText, AlertCircle,
  DollarSign, Upload, Settings,
  Workflow,
  Wallet,
  BarChart3,
  RotateCcw,
  Users2,
  RefreshCw,
  ShieldCheck,
  Percent,
} from 'lucide-react';

interface NavItemProps {
  to: string;
  icon: ReactNode;
  children: ReactNode;
  badge?: string | number;
}

function NavItem({ to, icon, children, badge }: NavItemProps) {
  return (
    <RouterNavLink
      to={to}
      end={to === '/'}
      className={({ isActive }) => `
        flex items-center gap-3 px-3 py-2 rounded-md text-sm transition-colors
        ${isActive
          ? 'bg-primary-soft text-primary font-medium'
          : 'text-foreground-muted hover:bg-background-muted hover:text-foreground'}
      `}
    >
      <span className="shrink-0">{icon}</span>
      <span className="flex-1 truncate">{children}</span>
      {badge !== undefined && (
        <span className="text-xs bg-muted px-1.5 py-0.5 rounded">{badge}</span>
      )}
    </RouterNavLink>
  );
}

function NavSection({ label, children }: { label: string; children: ReactNode }) {
  return (
    <div className="space-y-1">
      <p className="label-uppercase px-3 mb-2">{label}</p>
      {children}
    </div>
  );
}

export function Sidebar() {
  return (
    <aside className="w-64 shrink-0 border-r border-border bg-background-elevated flex flex-col h-screen sticky top-0">
      {/* Logo */}
      <div className="px-6 py-5 border-b border-border flex items-center gap-3">
        <Logo className="h-8 w-8" />
        <div>
          <p className="font-semibold leading-tight">ABASE</p>
          <p className="text-xs text-foreground-muted leading-tight">Painel</p>
        </div>
      </div>

      {/* Nav */}
      <nav className="flex-1 overflow-y-auto px-3 py-4 space-y-6">
        <NavSection label="Visão Geral">
          <NavItem to="/" icon={<LayoutDashboard className="h-4 w-4" />}>Dashboard</NavItem>
        </NavSection>

        <NavSection label="Operação">
          <NavItem to="/esteira" icon={<Workflow className="h-4 w-4" />}>Esteira (Novos e Renovações)</NavItem>
          <NavItem to="/aptos-renovar" icon={<RefreshCw className="h-4 w-4" />}>Aptos a Renovar</NavItem>
          <NavItem to="/associados" icon={<Users className="h-4 w-4" />}>Associados</NavItem>
          <NavItem to="/contratos" icon={<FileText className="h-4 w-4" />}>Contratos</NavItem>
        </NavSection>

        <NavSection label="Financeiro">
          <NavItem to="/financeiro" icon={<Wallet className="h-4 w-4" />}>Resumo Financeiro</NavItem>
          <NavItem to="/pagamentos" icon={<DollarSign className="h-4 w-4" />}>Pagamentos</NavItem>
          <NavItem to="/inadimplencia" icon={<AlertCircle className="h-4 w-4" />}>Inadimplência</NavItem>
          <NavItem to="/devolucoes" icon={<RotateCcw className="h-4 w-4" />}>Devoluções</NavItem>
        </NavSection>

        <NavSection label="Gestão">
          <NavItem to="/relatorios" icon={<BarChart3 className="h-4 w-4" />}>Relatórios</NavItem>
          <NavItem to="/importacao" icon={<Upload className="h-4 w-4" />}>Importação ETIPI</NavItem>
          <NavItem to="/usuarios" icon={<Users2 className="h-4 w-4" />}>Usuários</NavItem>
          <NavItem to="/acessos" icon={<ShieldCheck className="h-4 w-4" />}>Acessos por Papel</NavItem>
          <NavItem to="/comissoes" icon={<Percent className="h-4 w-4" />}>Comissões</NavItem>
          <NavItem to="/configuracoes" icon={<Settings className="h-4 w-4" />}>Configurações</NavItem>
        </NavSection>
      </nav>
    </aside>
  );
}
